export default __webpack_public_path__ + "static/media/promote_header.df24041e.png";